import _extends from "@babel/runtime/helpers/extends";
import _defineProperty from "@babel/runtime/helpers/defineProperty";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import React from "react";
import { mergeClasses } from "@magento/venia-ui/lib/classify";
import { shape, string, array } from "prop-types";
import defaultClasses from "./socialButtons.css";
import Button from "./button";
import { useSocButtons } from "../../talons/useSocButtons";
import { FormattedMessage } from "react-intl";
const SocialButtons = props => {
  const {
    buttons,
    mode,
    onClick,
    hasBottomSeparator,
    disclaimer
  } = props;
  const {
    buttonShape,
    visibleButtons,
    handleLogin,
    isShowMoreBtn,
    handleShowMore,
    errors,
    errorRef
  } = useSocButtons(_objectSpread({}, props));
  if (!Array.isArray(buttons) || !buttons.length) {
    return null;
  }
  const classes = mergeClasses(defaultClasses, props.classes);
  const list = visibleButtons.map(btn => /*#__PURE__*/React.createElement(Button, _extends({
    key: btn.type,
    buttonShape: buttonShape
  }, btn, {
    handleLogin: handleLogin,
    onClick: onClick
  })));
  const showMoreBtn = isShowMoreBtn ? /*#__PURE__*/React.createElement("button", {
    className: classes.showMore,
    onClick: handleShowMore
  }, /*#__PURE__*/React.createElement(FormattedMessage, {
    id: "amSocialLogin.showMore",
    defaultMessage: "Show More"
  })) : null;
  const errorMessage = errors && errors.message ? /*#__PURE__*/React.createElement("span", {
    ref: errorRef,
    className: classes.message
  }, errors.message) : null;
  return /*#__PURE__*/React.createElement("div", {
    className: "".concat(classes.root, " ").concat(!hasBottomSeparator ? classes.noBottom : "", " ").concat(classes[buttonShape], " ").concat(classes[mode])
  }, /*#__PURE__*/React.createElement("div", {
    className: classes.list
  }, list), showMoreBtn, errorMessage, disclaimer);
};
SocialButtons.propTypes = {
  buttons: array,
  classes: shape({
    root: string
  })
};
export default SocialButtons;